/*
 * @Author: Ygm
 * @Date: 2023-11-15 16:57:55
 * @LastEditors: Ygm
 * @LastEditTime: 2023-11-15 16:57:55
 * @Description: 控制页面缩放
 */
function zoom() {
  const keyCodeMap = {
    // 91: true, // command
    61: true,
    107: true, // 数字键盘 +
    109: true, // 数字键盘 -
    173: true, // 火狐 - 号
    187: true, // +
    189: true // -
  }

  // 覆盖[ctrl]command + [+]/[-]
  document.onkeydown = function (event) {
    //ratio = window.outerWidth / window.innerWidth;
    const e = event || window.event
    const ctrlKey = e.ctrlKey || e.metaKey
    if (ctrlKey && keyCodeMap[e.keyCode]) {
      e.preventDefault()
    } else if (e.detail) {
      // Firefox
      event.returnValue = false
    }
  }

  // 覆盖鼠标滚轮
  document.addEventListener(
    'wheel',
    e => {
      if (e.ctrlKey || e.metaKey) {
        if (detectZoom() > 120 && e.deltaY < 0) {
          e.preventDefault()
          return false
        }
        if (e.deltaY > 0) {
          // e.preventDefault()
          return false
        }
      }
    },
    { passive: false }
  )
}

// 检测浏览器缩放比例
function detectZoom() {
  let ratio = 0,
    screen = window.screen,
    ua = navigator.userAgent.toLowerCase()

  if (window.devicePixelRatio !== undefined) {
    ratio = window.devicePixelRatio
  } else if (~ua.indexOf('msie')) {
    if (screen.deviceXDPI && screen.logicalXDPI) {
      ratio = screen.deviceXDPI / screen.logicalXDPI
    }
  } else if (window.outerWidth !== undefined && window.innerWidth !== undefined) {
    ratio = window.outerWidth / window.innerWidth
  }

  if (ratio) {
    ratio = Math.round(ratio * 100)
  }

  return ratio
}

export default zoom



// WEBPACK FOOTER //
// ./src/utils/zoom.js